module.exports = __webpack_public_path__ + "static/media/logo-inverted.d93705bc.svg";